@if (!isInitializing()) {
  <app-header [navigationItems]="navigationItems" [welcomeMessage]="welcomeMessage()"></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
}
<app-spinner></app-spinner>
@if (toastMessage(); as toast) {
  <div
    class="app-toast app-toast--{{ toast.type }}"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <span class="app-toast__icon" aria-hidden="true">
      @switch (toast.type) {
        @case ('success') { ✓ }
        @case ('error') { × }
        @case ('warning') { ! }
        @case ('info') { i }
      }
    </span>
    <span class="app-toast__message">{{ toast.message }}</span>
    <button
      class="app-toast__close"
      type="button"
      aria-label="Dismiss notification"
      (click)="dismissToast()"
    >
      ×
    </button>
  </div>
}
